import React, { useState, useRef, useLayoutEffect } from 'react';

const GAP = 8;

const tagChipStyle = {
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#f5f5f5',
  border: '1px solid #e0e0e0',
  padding: '2px 6px',
  borderRadius: '4px',
  fontSize: '0.8rem',
  color: '#424242',
  flexShrink: 0,
  whiteSpace: 'nowrap',
};

const moreChipStyle = {
  fontSize: '0.8rem',
  color: '#666',
  fontWeight: 600,
  flexShrink: 0,
  whiteSpace: 'nowrap',
};

const TagChip = ({ tag }) => (
  <div style={tagChipStyle}>
    {tag.icon_url && (
      <img
        src={tag.icon_url}
        alt=""
        style={{ width: '16px', height: '16px', marginRight: '4px', objectFit: 'contain' }}
      />
    )}
    <span>{tag.label}</span>
  </div>
);

const TagsSummary = ({ tags }) => {
  const containerRef = useRef(null);
  const measureRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(tags.length);

  useLayoutEffect(() => {
    const recompute = () => {
      const container = containerRef.current;
      const measure = measureRef.current;
      if (!container || !measure) return;

      const containerWidth = container.clientWidth;
      const chipEls = measure.querySelectorAll('[data-chip]');
      const moreEl = measure.querySelector('[data-more]');
      const moreWidth = moreEl ? moreEl.offsetWidth : 0;

      let used = 0;
      let count = 0;
      for (let i = 0; i < chipEls.length; i++) {
        const w = chipEls[i].offsetWidth;
        const widthIfAdded = used + (count > 0 ? GAP : 0) + w;
        const remaining = chipEls.length - (i + 1);
        const moreReserve = remaining > 0 ? GAP + moreWidth : 0;

        if (widthIfAdded + moreReserve > containerWidth) break;
        used = widthIfAdded;
        count++;
      }
      setVisibleCount(count);
    };

    recompute();
    const ro = new ResizeObserver(recompute);
    if (containerRef.current) ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, [tags]);

  const visible = tags.slice(0, visibleCount);
  const hidden = tags.length - visibleCount;

  return (
    <div
      ref={containerRef}
      style={{ display: 'flex', alignItems: 'center', gap: `${GAP}px`, width: '100%', minWidth: 0, overflow: 'hidden', position: 'relative' }}
    >
      <div
        ref={measureRef}
        aria-hidden
        style={{ position: 'absolute', top: 0, left: 0, visibility: 'hidden', display: 'flex', gap: `${GAP}px`, pointerEvents: 'none' }}
      >
        {tags.map((tag, i) => (
          <div key={`m-${i}`} data-chip style={tagChipStyle}>
            {tag.icon_url && (
              <img
                src={tag.icon_url}
                alt=""
                style={{ width: '16px', height: '16px', marginRight: '4px', objectFit: 'contain' }}
              />
            )}
            <span>{tag.label}</span>
          </div>
        ))}
        <span data-more style={moreChipStyle}>+{tags.length} more</span>
      </div>

      {visible.map((tag, i) => (
        <TagChip key={i} tag={tag} />
      ))}
      {hidden > 0 && <span style={moreChipStyle}>+{hidden} more</span>}
    </div>
  );
};

export default TagsSummary;
